export const HelpConstant = {
    API: ''
}

export const HelpAPIConstant = {
    TAGS: 'HelpItems/tags',
    GET_HELP_ITEMS : 'HelpItems',
    ADD_HELP_ITEMS : 'HelpItems/CreateHelpItem',
    UPDATE_HELP_ITEMS : 'HelpItems',
    DELETE_HELP_ITEM : 'HelpItems', //api/HelpItems/{helpItemDocumentId}
    ATTACHMENTS : 'Attachments', ///api/Attachments/{fileName}
    GET_AS_URI_BY_FILENAME : 'Attachments/GetSASUriByFileName', ///api/Attachments/{fileName}
    ///api/Attachments/GetSASUriByFileName/{fileName}
} 